/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Wiki_Recentlyviewed1Inputs */



/**

* @param {_Wiki_Recentlyviewed1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _wiki_recentlyviewed1 = /** @type {((inputs?: _Wiki_Recentlyviewed1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Wiki_Recentlyviewed1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Zuletzt angesehen")
});
export { _wiki_recentlyviewed1 as "_wiki_recentlyViewed" }